import siteConfig from "../cordovaSiteConfig.json";

let showCDVModal = false;

const isCordovaApp =
  typeof document !== "undefined" &&
  document.URL.indexOf("http://") === -1 &&
  document.URL.indexOf("https://") === -1;

const readFile = fileEntry =>
  new Promise((resolve, reject) => {
    fileEntry.file(
      file => {
        const reader = new FileReader();

        reader.onloadend = function() {
          resolve(JSON.parse(this.result));
        };
        reader.readAsText(file);
      },
      err => {
        console.log(`Read file failed... ${err}`);
        reject(err);
      }
    );
  });

const cordovaFetchSiteConfig = () => Promise.resolve(siteConfig.site);

const cordovaFetchSiteLanguages = () =>
new Promise((resolve, reject) => {
  const siteDir = `${window.cordova.file.applicationDirectory}/www/${siteConfig.site.subdomain}`;
  window.resolveLocalFileSystemURL(
    siteDir,
    fs => {
      fs.getFile(
        "cordovaSiteDictionaries.json",
        null,
        fileEntry => readFile(fileEntry).then(data => resolve(data)),
        err => {
          console.log("`fs.getFile failed... ", err);
          reject(err);
        }
      );
    },
    err => {
      console.log(`Create FS failed... ${err}`);
      reject(err);
    }
  );
});

const cordovaFetchBooksAndChapters = bibleId =>
  new Promise((resolve, reject) => {
    const siteDir = `${window.cordova.file.applicationDirectory}/www/${
      siteConfig.site.subdomain
    }`;
    window.resolveLocalFileSystemURL(
      `${siteDir}/${bibleId}`,
      fs => {
        fs.getFile(
          "books.json",
          null,
          fileEntry => readFile(fileEntry).then(data => resolve(data.data)),
          err => {
            console.log("`fs.getFile failed... ", err);
            reject(err);
          }
        );
      },
      err => {
        console.log(`Create FS failed... ${err}`);
        reject(err);
      }
    );
  });

const cordovaFetchChapter = (bibleId, chapterId, parallels = []) =>
  new Promise((resolve, reject) => {
    const siteDir = `${window.cordova.file.applicationDirectory}/www/${
      siteConfig.site.subdomain
    }`;
    window.resolveLocalFileSystemURL(
      `${siteDir}/${bibleId}/chapters`,
      fs => {
        fs.getFile(
          `${chapterId}.json`,
          null,
          fileEntry =>
            readFile(fileEntry).then(data => {
              const chapter = data.data;
              return resolve(chapter);
            }),
          err => {
            console.log("`fs.getFile failed... ", err);
            reject(err);
          }
        );
      },
      err => {
        console.log(`Create FS failed... ${err}`);
        reject(err);
      }
    );
  });

const cordovaFetchBible = bibleId =>
  new Promise((resolve, reject) => {
    const siteDir = `${window.cordova.file.applicationDirectory}/www/${
      siteConfig.site.subdomain
    }`;
    window.resolveLocalFileSystemURL(
      `${siteDir}/${bibleId}`,
      fs => {
        fs.getFile(
          "bible.json",
          null,
          fileEntry => readFile(fileEntry).then(data => resolve(data.data)),
          err => {
            console.log("`fs.getFile failed... ", err);
            reject(err);
          }
        );
      },
      err => {
        console.log(`Create FS failed... ${err}`);
        reject(err);
      }
    );
  });

const cordovaFetchBibles = bibleIds => {
  const promises = [];
  bibleIds.forEach(bibleId => promises.push(cordovaFetchBible(bibleId)));
  return Promise.all(promises).then(array => ({ data: array }));
};

const toggleModal = () => {
  showCDVModal = !showCDVModal;
  document.dispatchEvent(
    new CustomEvent("cdvShowModal", {
      detail: { show: showCDVModal }
    })
  );
};

const unzipBibles = async progressFunc => {
  // const bibleList = siteConfig.site.bibles;
  toggleModal();
  await new Promise((resolve, reject) => {
    window.zip.unzip(
      `${window.cordova.file.applicationDirectory}/www/${
        siteConfig.site.subdomain
      }.zip`,
      `${window.cordova.file.applicationDirectory}/www/${
        siteConfig.site.subdomain
      }`,
      status => {
        if (status === 0) {
          // console.log("Everything unzipped OK");
          toggleModal();
          resolve();
        } else if (status === -1) {
          toggleModal();
          reject();
          console.log("Everything unzipped wrong ...");
        }
      },
      progressFunc
    );
  });
};

const cordovaShare = (message, url) => {
  const promise = new Promise((resolve, reject) => {
    const options = {
      message,
      url
    };
    const onSuccess = result => resolve(result.completed || result.app);
    const onError = msg => reject(msg);

    window.plugins.socialsharing.shareWithOptions(options, onSuccess, onError);
  });

  return promise;
};
// const onProgressUpdate = progress =>
//   console.log(
//     `Installing:, ${Math.round(progress.loaded / progress.total * 100)}%`
//   );

// const setupCDVFile = () => {
//   // unzipBibles(onProgressUpdate);
//   const siteDir = `${window.cordova.file.applicationDirectory}/www/${
//     siteConfig.site.subdomain
//   }`;
//   window.resolveLocalFileSystemURL(
//     siteDir,
//     fs => {
//       console.log(`file system open: ${fs.name}`);
//       const reader = fs.createReader();
//       reader.readEntries(
//         entries => {
//           entries.forEach(entry => {
//             // console.log(`entry: ${JSON.stringify(entry)}`);
//           });
//         },
//         err => {
//           console.log(err);
//         }
//       );
//     },
//     err => {
//       console.log(`Create FS failed... ${err}`);
//     }
//   );
// };

const isOnline = () => {
  // navigator.isOnline might be better
  const networkState = navigator.connection.type;
  return networkState !== "none";
};

/** **************************** */
/** cordova media (audio) methods */
/* global Media, MusicControls */
/** **************************** */

/* eslint lines-between-class-members: ["error", "always", { exceptAfterSingleLine: true }] */
class CordovaAudio {
  audioFile = null;
  audioMetaData = null;
  paused = false;
  ended = false;
  playing = false;
  starting = false;
  autoPlay = false;
  cordovaTimer = null;
  isMusicControls = false;

  cordovaSetTimer = (timerFunc, interval) => {
    this.cordovaTimer = setInterval(() => {
      timerFunc();
    }, interval);
  };

  cordovaClearTimer = () => {
    clearInterval(this.cordovaTimer);
  };

  cordovaPrepAudio = (url = "", updateState, handleEnded, meta) => {
    // const promise = new Promise((resolve, reject) => {

    this.audioMetaData = { ...meta };
    if (this.audioFile !== null) {
      this.audioFile.release();
      this.paused = false;
      this.ended = false;
      this.playing = false;
    }

    this.audioFile = new Media(
      url,
      () => {
        // console.log("playAudio():Audio Success");
      },
      err => {
        console.log(`playAudio():Audio Error: ${err}`);
      },
      status => {
        // console.log("audio status:", status);
        // audioStatus = status;
        switch (status) {
          case Media.MEDIA_STOPPED:
            this.cordovaClearTimer();
            if (this.playing) {
              this.paused = false;
              this.ended = true;
              this.playing = false;
              this.starting = false;
              this.autoPlay = true;
              handleEnded();
              updateState({ isPlayPending: true });
            } else {
              this.paused = false;
              this.ended = true;
              this.playing = false;
              this.starting = false;
              this.autoPlay = false;
              updateState();
            }
            break;
          case Media.MEDIA_PAUSED:
            this.paused = true;
            this.ended = false;
            this.playing = false;
            this.starting = false;
            this.autoPlay = false;
            this.cordovaClearTimer();
            updateState();
            break;
          case Media.MEDIA_RUNNING:
            this.paused = false;
            this.ended = false;
            this.playing = true;
            this.starting = false;
            this.autoPlay = false;
            // console.log("trying to makeMusicControls!!!");
            if (!this.isMusicControls) this.makeMusicControls();
            updateState({ isPlayPending: this.starting, isLoading: false });
            break;
          case Media.MEDIA_STARTING:
            this.paused = false;
            this.ended = false;
            this.playing = false;
            this.starting = true;
            this.autoPlay = false;
            // MusicControls.updateIsPlaying(true);
            updateState({ isPlayPending: this.starting });
            break;
          default:
            this.paused = false;
            this.ended = false;
            this.playing = false;
            this.starting = false;
            this.autoPlay = false;
            this.cordovaClearTimer();
            updateState();
        }
      }
    );
    // this.makeMusicControls();
  };

  cordovaPlayAudio = () => {
    if (this.audioFile) {
      this.audioFile.play({ playAudioWhenScreenIsLocked: true });
      this.paused = false;
      this.ended = false;
      this.playing = true;
      // if (!this.isMusicControls) this.makeMusicControls();
      if (this.isMusicControls) MusicControls.updateIsPlaying(true);
    }
  };

  cordovaPauseAudio = () => {
    if (this.audioFile) {
      this.audioFile.pause();
      this.paused = true;
      this.ended = false;
      this.playing = false;
      MusicControls.listen();
      MusicControls.updateIsPlaying(false);
    }
  };

  cordovaToggleAudio = () => {
    if (this.audioFile) {
      if (this.cordovaAudioIsPlaying()) {
        this.cordovaPauseAudio();
      } else {
        this.cordovaPlayAudio();
      }
    }
  };

  cordovaStopAudio = () => {
    if (this.audioFile) {
      this.audioFile.stop();
      this.paused = false;
      this.ended = true;
      this.playing = false;
      this.cordovaClearTimer();
      this.audioFile.release();
      MusicControls.destroy();
      this.isMusicControls = false;
    }
  };

  cordovaAudioSeekTo = position => {
    if (this.audioFile) {
      const duration = this.audioFile.getDuration();
      let checkedPos = position < 0 ? 0 : position;
      checkedPos = position > duration ? duration : position;
      this.audioFile.seekTo(checkedPos * 1000);
      MusicControls.updateElapsed({
        elapsed: checkedPos,
        isPlaying: true
      });
    }
  };

  cordovaAudioIsPaused = () => {
    if (this.audioFile) {
      return this.paused;
    }
    return false;
  };

  cordovaAudioIsEnded = () => {
    if (this.audioFile) {
      return this.ended;
    }
    return false;
  };

  cordovaAudioIsPlaying = () => {
    if (this.audioFile) {
      return this.playing;
    }
    return false;
  };

  cordovaAudioIsAutoPlay = () => this.autoPlay;

  cordovaGetCurrentPosition = () => {
    const promise = new Promise((resolve, reject) => {
      if (this.audioFile)
        return this.audioFile.getCurrentPosition(
          position => {
            const duration = this.audioFile.getDuration();
            if (position >= 0 && duration >= 0) {
              //  const progress = ((duration - position) / duration) * 100;
              // return resolve({ duration, position, progress });

              MusicControls.updateElapsed({
                elapsed: position,
                isPlaying: true
              });
              return resolve({ duration, position });
            }
            return resolve({
              duration: 0,
              position: 0
              // progress: 0
            });
          },
          err => {
            console.log(`Error getting pos=${err}`);
            return reject(err);
          }
        );
      return reject(new Error("no audio file"));
    });

    return promise;
  };

  cordovaMusicEvents = action => {
    const { message, position } = JSON.parse(action);

    // console.log("action:", action);
    switch (message) {
      case "music-controls-next":
      case "music-controls-skip-forward":
        // this.audioFile.getCurrentPosition().then(position => {
        //   this.cordovaAudioSeekTo(position + 10);
        // });
        break;
      case "music-controls-previous":
      case "music-controls-skip-backward":
        // this.audioFile.getCurrentPosition().then(position => {
        //   this.cordovaAudioSeekTo(position - 10);
        // });
        break;
      case "music-controls-pause":
        this.cordovaPauseAudio();
        break;
      case "music-controls-play":
        this.cordovaPlayAudio();
        break;
      case "music-controls-destroy":
        break;

      // External controls (iOS only)
      case "music-controls-toggle-play-pause":
        this.cordovaToggleAudio();
        break;
      case "music-controls-seek-to":
        this.cordovaAudioSeekTo(position);
        break;

      // Headset events (Android only)
      case "music-controls-media-button":
        this.cordovaToggleAudio();
        break;
      case "music-controls-headset-unplugged":
        if (!this.stop) this.cordovaPauseAudio();
        break;
      case "music-controls-headset-plugged":
        // Do nothing
        break;
      default:
        break;
    }
  };

  makeMusicControls = () => {
    const { iconImage } = siteConfig.site;
    if (this.isMusicControls) MusicControls.destroy();
    const duration =
      this.audioFile && this.audioFile.getDuration() > 0
        ? this.audioFile.getDuration()
        : 0;
    // console.log("makeMusicControls: duration:", duration);
    MusicControls.create(
      {
        track: this.audioMetaData.track,
        artist: this.audioMetaData.artist,
        cover: iconImage
          ? `https://global-bible-images.s3.amazonaws.com/${iconImage}`
          : "mstile-310x310.png",
        isPlaying: true,
        dismissable: true,
        hasPrev: false,
        hasNext: false,
        hasClose: false,
        // iOS Only
        duration,
        elapsed: 0,
        hasSkipForward: false,
        hasSkipBackward: false,
        skipForwardInterval: 10,
        skipBackwardInterval: 10,
        hasScrubbing: true
      },
      () => {
        this.isMusicControls = true;
        // console.log("created MusicControls");
        MusicControls.subscribe(action => this.cordovaMusicEvents(action));
        MusicControls.listen();
      },
      err => console.log("failed to create MusicControls:", err)
    );

    this.isMusicControls = true;
    // console.log("created MusicControls");
    MusicControls.subscribe(action => this.cordovaMusicEvents(action));
    MusicControls.listen();
  };
}

export {
  isCordovaApp,
  cordovaFetchSiteConfig,
  cordovaFetchSiteLanguages,
  cordovaFetchBooksAndChapters,
  cordovaFetchChapter,
  cordovaFetchBibles,
  cordovaFetchBible,
  cordovaShare,
  CordovaAudio,
  // setupCDVFile,
  isOnline,
  unzipBibles
};
